import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseURL } from "../../../../config/api";
import { CustomDataGrid } from "../../../../components/CustomDataGrid";


export const Terminals = () => {
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const columns: GridColDef[] = [
        {
            field: "name",
            headerName: "Name",
            flex: 2,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link
                        to="/admin/settings/terminals/edit-terminal"
                        state={params.id} className="underline text-[#0000ff]"
                    >
                        {params.value}
                    </Link>
                );
            },
        },
        {
            field: "ipAddress",
            headerName: "IpAddress",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "terminalDeviceId",
            headerName: "Device Id",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "locationId",
            headerName: "Location Id",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "isActive",
            headerName: "isActive?",
            flex: 1,
            editable: false,
            sortable: false,
        }
    ];

    useEffect(() => {
        emptySearchApiCall(paginationModel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const emptySearchApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}terminalDevices/GetTerminalDevicesPaging/${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.terminalDevices?.map((item: any) => {
                    return {
                        ...item,
                        isActive: item?.isActive ? "Yes" : "No",
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });
    }

    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full bg-white p-4 rounded-md">
                <div className="flex items-center justify-end py-2">
                    <div className="flex items-center gap-2.5">
                        <button className={`px-[8px] py-[6px] bg-primary rounded-lg border text-white flex items-center gap-1.5`}
                            onClick={() => navigate("/admin/settings/terminals/add-terminal")}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">Terminal</span>
                        </button>

                    </div>
                </div>
                <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                        <div className="flex items-center gap-1.5">

                            <h2 className={`text-lg font-semibold text-[#1D2939]`}>Terminals</h2>
                        </div>
                    </div>

                    <CustomDataGrid
                        filteredRows={searchTableData}
                        columns={columns?.map(col => ({
                            ...col,
                            headerClassName: "bg-[#F9FAFB]",
                        }))}
                        loading={loading}
                        totalLength={totalLength}
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                    />
                </div>
            </div>

        </div>
    )
}